import { useState } from "react"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { Input, Spin } from "antd"
import { urlapi } from "../../lib/backend/data"

const EscaneoBultoRemoverInput = (props) => {
    const [ codigo, setCodigo ] = useState('')
    const [ loading, setLoading ] = useState(false)
    const session = useSelector(state => state.miusuario)

    const handleSubmitEstaneo = (e) => {
        e.preventDefault()
        consultarCodigo()
    }

    const consultarCodigo = async () => {
        if(!codigo) return toast.error("Marca un código primero")
        setLoading(true)
        const idbulto = codigo
        return fetch(`${urlapi}/bodega/expediciones/escanear-bulto?id=${codigo}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${session.tokenSession}`
            }
          })
          .then(pros => {
            setCodigo('')
            return pros.json()
          })
          .then(async pros => {
              if(!pros){
                toast.error('Sin datos del servidor')
              } else if(pros.errorMessage){
                toast.error(pros.errorMessage)
              } else if(pros.deletedCount){
                toast.success("Eliminado exitosamente")
                if(props.onScanned) props.onScanned(idbulto)
              }
              setLoading(false)
          })
          .catch(async error => {
              console.log(error)
              setLoading(false)
            return toast.error("No pudimos consultar la información de este pedido, intente de nuevo recargando la página")
          })
    }

    const handleChangeCodigo = (e) => {
        const { value } = e.target
        return setCodigo(value)
    }

    const formulario = () => {
        if(loading) return <Spin animation="border" />

        return <form onSubmit={handleSubmitEstaneo}>
        <Input className="form-control" value={codigo} placeholder="ESCANEA BULTO AQUÍ PARA REMOVER" onChange={handleChangeCodigo} />
        </form>
    }

    return <div>
        {formulario()}
    </div>
}

export default EscaneoBultoRemoverInput